import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-battery",
  "use": "icon-battery-usage",
  "viewBox": "0 0 25 12",
  "content": "<symbol viewBox=\"0 0 25 12\" id=\"icon-battery\"><path d=\"M2.667 1.333C1.747 1.333 1 2.08 1 3v6c0 .92.746 1.667 1.667 1.667h16.666C20.253 10.667 21 9.92 21 9V3c0-.92-.746-1.667-1.667-1.667H2.667zm0-1h16.666A2.667 2.667 0 0 1 22 3v6a2.667 2.667 0 0 1-2.667 2.667H2.667A2.667 2.667 0 0 1 0 9V3A2.667 2.667 0 0 1 2.667.333z\" opacity=\".35\" /><path d=\"M23 4v4a2.17 2.17 0 0 0 0-4\" opacity=\".4\" /><rect x=\"2\" y=\"2.333\" width=\"18\" height=\"7.333\" rx=\"1.333\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/battery.svg
// module id = WLkG
// module chunks = 22